import React from 'react'

import { SignUp, Navbar, FooterOverlay } from '../../components'

const Signup = () => {
  return (
    <div>
      <Navbar />
      <SignUp />
      <FooterOverlay />
    </div>
  )
}

export default Signup
